import Vue from 'vue';
import { SelectSymbol } from '../mixins/SelectSymbol';
function selectHandler (element, vnode, onSelect) {
  if (typeof onSelect === 'function') {
    return onSelect;
  }

  return (isSelected) => {
    if (vnode && vnode.componentInstance && 'select' in vnode.componentInstance && typeof vnode.componentInstance.select === 'function') {
      vnode.componentInstance.select(isSelected);
    } else { element.classList.toggle('selected', isSelected); }
  };
}

Vue.directive('selectable', {
  inserted (el, binding, vnode) {
    el.dataset.selectable = binding.arg || '';
    el[SelectSymbol] = selectHandler(el, vnode, binding.value);
  },

  update (el, binding, vnode) {
    el.dataset.selectable = binding.arg || '';
    el[SelectSymbol] = selectHandler(el, vnode, binding.value);
  }
});
